import { useDispatch, useSelector } from 'react-redux';
import { getAllUsers } from 'redux/slices/userSlice';

export const useRefreshUserTab = () => {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const selectedNode = useSelector((state) => state.selectedNode);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  let uservalue;

  uservalue = {
    ouName:
      role === 'ouadmin'
        ? adminOuName && adminOuName.dnName
        : selectedNode.selectedNode && selectedNode.selectedNode.dnName
        ? selectedNode.selectedNode.dnName
        : localStorage.getItem('domainDn'),
    fqdn: selectedNode.domainName || localStorage.getItem('domain'),
    page: selectedNode.pageNumber,
    pageSize: selectedNode.pageSize,
    searchQuery: selectedNode.searchQuery,
    isDescending: selectedNode.isDescending,
    sortType: selectedNode.sortType,
    usersFilter: selectedNode.usersFilter,
  };

  const refreshUserTab = () => {
    dispatch(getAllUsers(uservalue));
  };

  return refreshUserTab;
};
